<template>
  <div class="email-attendees-form">
    <div class="flex-inputs">
      <div class="input">
        <label>Reply-To Email</label>
        <input type="text" v-model="reply_to_email" />
      </div>
      <div class="input">
        <label>To</label>
        <v-select
          :clearable="false"
          :options="to_options"
          v-model="to_email_option"
          @input="handleEmailOptionSelect"
        />
        <v-select
          v-if="to_email_option === 'Attendees by Ticket Type'"
          :clearable="false"
          :options="ticket_types"
          v-model="to_ticket_type"
        />
      </div>
      <div class="input">
        <label>Subject</label>
        <input type="text" v-model="subject" />
      </div>
    </div>

    <div class="input">
      <CKEditor
        label="Message"
        :inputData="message"
        @updateData="updateMessage"
      />
    </div>
    <div class="input">
      <check :value="true" v-model="includeDetails"
        >Include event details and a link to print tickets</check
      >
    </div>
    <div class="input">
      <label>Send Test Message To</label>
      <input type="text" v-model="test_email" />
      <button @click="sendTest" class="orange-button">Send Test</button>
    </div>
    <div class="input full">
      <label>Send Email:</label>
      <div class="input">
        <radio v-model="email_schedule_type" value="Now">Now</radio>
      </div>
      <div class="input specific-date">
        <radio v-model="email_schedule_type" value="datetime"
          >Specific Date and Time</radio
        >
        <input
          @click="$refs.start_time.isOpen = true"
          type="text"
          readonly
          :value="selected_time"
        />
        <datetime
          hidden
          ref="start_time"
          type="datetime"
          v-model="email_schedule"
        ></datetime>
      </div>
      <div class="input dhm-before">
        <radio v-model="email_schedule_type" value="before_event"></radio>
        <div class="input">
          <input v-model="email_schedule['days']" type="number" />
          Days
        </div>
        <div class="input">
          <input v-model="email_schedule['hours']" type="number" />
          Hours
        </div>
        <div class="input">
          <input v-model="email_schedule['minutes']" type="number" />
          Minutes
        </div>
        <p>Before the Event</p>
      </div>
    </div>
    <div class="controls">
      <button class="orange-button" @click="sendEmailAttendees">Save</button>
      <button class="cancel-button" @click="$emit('cancel')">Cancel</button>
    </div>
    <popup :title="to_email_option" :show="showModal">
      <div
        class="specific_attendees_lists"
        v-if="to_email_option === 'Specific Attendees'"
      >
        <div class="col-3">
          <h3>Guests:</h3>
          <draggable class="list-group" :list="guests" group="people">
            <div
              class="list-group-item"
              v-for="(guest, index) in guests"
              :key="index"
            >
              {{ guest.first_name }} {{ guest.last_name }}
            </div>
          </draggable>
        </div>

        <div class="col-3">
          <h3>Send Emails To:</h3>
          <draggable
            class="list-group"
            :list="specific_attendees_emails"
            group="people"
          >
            <div
              class="list-group-item"
              v-for="(attendees, index) in specific_attendees_emails"
              :key="index"
            >
              {{ attendees.first_name }} {{ attendees.last_name }}
            </div>
          </draggable>
        </div>
        <div>
          <button class="orange-button" @click="setRecipients">Save</button>
        </div>
      </div>
    </popup>
  </div>
</template>

<script>
import CKEditor from "@/components/Tools/CKEditor.vue";
import Popup from "../components/Popup.vue";
import PrettyCheck from "pretty-checkbox-vue/check";
import PrettyRadio from "pretty-checkbox-vue/radio";
import axios from "axios";
import { Datetime } from "vue-datetime";
import draggable from "vuedraggable";
import Swal from "sweetalert2";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const functions = fb.default.functions;
const auth = fb.default.auth;
var moment = require("moment");

export default {
  props: ["event"],
  components: {
    CKEditor,
    check: PrettyCheck,
    radio: PrettyRadio,
    datetime: Datetime,
    popup: Popup,
    draggable,
  },
  data() {
    return {
      message: null,
      name: null,
      reply_to_email: auth.currentUser.email,
      to_email_option: "All Attendees",
      to_ticket_type: "Select Ticket Type",
      subject: `Message to attendees of ${this.event.title}`,
      includeDetails: true,
      test_email: auth.currentUser.email,
      email_schedule_type: null,
      email_schedule: {},
      guests: [],
      ticket_types: [],
      to_options: [
        "All Attendees",
        "Specific Attendees",
        "Attendees by Ticket Type",
      ],
      specific_attendees_emails: [],
      showModal: false,
    };
  },
  watch: {
    email_schedule_type() {},
  },
  firestore() {
    return {
      guests: db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("guest"),
    };
  },
  async mounted() {
    let tickets = await db
      .collection("event")
      .doc(this.$route.params.id)
      .collection("ticket")
      .get()
      .catch((err) => {
        throw err;
      });

    this.ticket_types = tickets.docs.map((d) => {
      return d.data().name;
    });
  },
  computed: {
    selected_time: {
      get() {
        return this.email_schedule
          ? moment(this.email_schedule).format("MM/DD/YYYY hh:mm a")
          : null;
      },
      set(timestring) {
        this.email_schedule = new Date(timestring).valueOf();
      },
    },
  },
  methods: {
    updateMessage(data) {
      this.message = data;
    },
    sendTest() {},
    async sendEmailAttendees() {
      let to_emails = [];
      if (this.to_email_option === "All Attendees") {
        this.guests.map((guest) => {
          if (guest.email) {
            to_emails.push({
              email: guest.email,
              name: `${guest.first_name} ${guest.last_name}`,
              type: "to",
            });
          }
        });
      } else if (this.to_email_option === "Specific Attendees") {
        this.specific_attendees_emails.map((guest) => {
          if (guest.email) {
            to_emails.push({
              email: guest.email,
              name: `${guest.first_name} ${guest.last_name}`,
              type: "to",
            });
          }
        });
      } else if (this.to_email_option === "Attendees by Ticket Type") {
        this.guests.map((guest) => {
          if (guest.ticket.name === this.to_ticket_type && guest.email) {
            to_emails.push({
              email: guest.email,
              name: `${guest.first_name} ${guest.last_name}`,
              type: "to",
            });
          }
        });
      } else {
        return Swal.fire({
          title: "Please select email recipients",
          text: "You must select recipients before sending emails",
          type: "warn",
        });
      }
      let sendEmail = functions.httpsCallable("sendEmail");
      let emailAttendees = await sendEmail({
        template_name: "journey-email-attendees",
        to_email: to_emails,
        email_schedule_type: this.email_schedule_type,
        date: this.email_schedule,
        global_merge_vars: [
          {
            name: "message",
            content: this.message,
          },
        ],
        email_attendee_message: {
          subject: this.subject,
          headers: {
            "Reply-To": this.reply_to_email,
          },
        },
      })
        .then((res) => {
          this.message = null;
          this.to_email_option = "All Attendees";
          return Swal.fire(
            "Success",
            "Posted emails successfully",
            "success"
          );
        })
        .catch((err) => {
          this.message = null;
          this.to_email_option = "All Attendees";
          return Swal.fire(
            "Error",
            `${err.message}`,
            "error"
          );
        });
    },
    handleEmailOptionSelect(value) {
      if (value === "Specific Attendees") this.showModal = true;
    },
    closePopup() {
      this.showModal = false;
    },
    setRecipients() {
      this.showModal = false;
      return this.specific_attendees_emails;
    },
  },
};
</script>

<style lang="scss">
.email-attendees-form {
  .input {
    margin: 20px 0;
    input {
      margin-top: 10px;
    }
    .v-select {
      margin-top: 10px;
    }
  }

  .flex-inputs {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    .input {
      width: 45%;
    }
  }
  .input.full {
    .input {
      margin: 10px 20px 10px 0 !important;
    }
  }
  .dhm-before {
    display: flex;
    align-items: baseline;
    .input {
      margin-right: 20px;
    }
    p {
      white-space: pre;
    }
  }

  .specific-date {
    display: flex;
    align-items: baseline;
  }
}

.ckeditor {
  width: 100%;
  p {
    min-height: 200px;
  }
  label {
    margin-bottom: 10px;
    display: inline-block;
  }
}

.orange-button {
  margin-top: 10px;
  background-color: #fba500;
  padding: 10px 20px 10px 20px;
  color: white;
  font-size: 15px;
  border: none;
  border-radius: 3px;
  margin-right: 7px;
}

.cancel-button {
  margin-top: 10px;
  background-color: #f7f7f7;
  padding: 10px 20px 10px 20px;
  color: #363636;
  font-size: 15px;
  border: 1px solid #363636;
  border-radius: 3px;
}

.specific_attendees_lists {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  cursor: move;
}

.list-group-item:last-child {
  margin-bottom: 0;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.list-group-item:first-child {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
</style>
